import React from 'react';
import './tasks-list-item-view.css';
import { func, string, bool } from 'prop-types';

const TasksListItemView = ({
  label, important, completed, edit,
  onToggleImportant, onToggleCompleted, onChangeEditedTask, onSubmitEditedTask,
  toggleEdit, handleModal,
  editedValue
}) => {
  let classNames = 'app-list-item d-flex justify-content-between'

  if (important) {
    classNames += ' important'
  }

  if (completed) {
    classNames += ' completed'
  }
  if (edit) {
    classNames += ' active'
  }

  return (
    <div className={classNames}>
      {edit ?
        (<input
          type="text"
          onChange={event => onChangeEditedTask(event)}
          onKeyUp={event => onSubmitEditedTask(event)}
          defaultValue={label}
          placeholder={!editedValue ? label : 'Введите текст задачи'}
        />) :
        (<span
          className="app-list-item-label"
          onClick={onToggleCompleted}
        >
          {label}
        </span>)
      }
      <div className="d-flex justify-content-center align-items-center">
        <button className="btn btn-edit btn-sm" onClick={() => toggleEdit()}>
          {edit ? <i className="fa fa-times" /> : <i className="fa fa-pencil" />}
        </button>
        <button
          type="button"
          className="btn-important btn-sm"
          onClick={onToggleImportant}>
          <i className="fa fa-exclamation" />
        </button>

        <button
          type="button"
          className="btn-trash btn-sm"
          onClick={() => handleModal()}
        >
          <i className="fa fa-trash-o" />
        </button>

        <button type="button"
          className="btn-completed btn-sm"
          onClick={onToggleCompleted}
        >
          {completed ? <i className="fa fa-check-square-o" /> : <i className="fa fa-square-o" />}
        </button>
      </div>
    </div>
  )
}

TasksListItemView.propTypes = {
  onToggleShowModal: func,
  onToggleCompleted: func,
  onToggleImportant: func,
  onChangeEditedTask: func,
  onSubmitEditedTask: func,
  toggleEdit: func,
  handleModal: func,
  label: string,
  important: bool,
  completed: bool,
  edit: bool,
  editedValue: string,
}

TasksListItemView.defaultProps = {
  onToggleCompleted: () => { },
  onToggleShowModal: () => { },
  onToggleImportant: () => { },
  onChangeEditedTask: () => { },
  onSubmitEditedTask: () => { },
  toggleEdit: () => { },
  handleModal: () => { },
  label: '',
  important: false,
  completed: false,
  edit: false,
  editedValue: '',
}

export default TasksListItemView